/*
 * @@Copyright (c): Knowdee All rights reserved.
 * @Description: 转人工相关逻辑（对接魔方）
 * @Author: Type your email address
 * @LastEditors: wangwz@knowdee.com
 * @Date: 2022-11-28 16:42:39
 * @LastEditTime: 2023-11-14 17:28:41
 * @FilePath: /client-h5-v2/src/common-ts/toAgentMF.ts
 */
import cubeManual from 'cubeManual'
import store from '@/store/index'
import { getCookie, setCookie, throttle } from './utils'
import { ElMessage } from 'element-plus'
console.log('智联招聘---转人工---魔方sdk')

const env = window.botV2GlobalProperties.NODE_ENV

// 调用魔方sdk的loadingScoketIo方法引入socketio
cubeManual.loadingSocketIo()

export const initToAgentMF = () => {
  // 初始化魔方数据
  const initOption = {
    mofangHost: env.indexOf('development') > -1 ? 'https://test.cube.lenovo.com' : getCookie('mfHost'), // 调用的魔方接口的地址，如果不传，则调用本地，之后需要本地进行转发
    socketHost: env.indexOf('development') > -1 ? 'https://test.cube.lenovo.com' : getCookie('mfSocketHost'), // 链接的socketio的地址，如果不传，则调用本地，之后需要本地进行转发
    userId: getCookie('userId') || localStorage.getItem('userId') || store.getters['session/userId'] || '' // 登录用户信息，如不传则是匿名登录,可不传
  }

  // 开发环境固定调试地址
  if (window.botV2GlobalProperties.NODE_ENV === 'development') {
    initOption.mofangHost = 'https://test.cube.lenovo.com'
    initOption.socketHost = 'https://test.cube.lenovo.com'
  }

  console.log('%c【转人工】initOption：' + JSON.stringify(initOption), 'color:#000;background:#D5EEFF;padding:4px;border-radius:5px')

  // 调用初始化方法
  cubeManual.initOpt(initOption)
}

export const historyMF = () => {
  // 调用魔方sdk的history方法支持刷新重连
  // cubeManual.history()
  return cubeManual.history()
}

// 监听工程师信息
cubeManual.on('manual_engineer_infor', (res: any) => {
  console.log('%c【监听工程师信息 manual_engineer_infor：' + JSON.stringify(res), 'color:#000;background:#D5EEFF;padding:4px;border-radius:5px')
  // 是否为重复消息
  const isRepeatMessage = res.engineer_name === store.getters['dialog/engineerInfoMF'].engineer_name
  const isShowTips = (res.engineer_name && !isRepeatMessage)
  // 如果工程师信息不为空且不为重复消息则提示
  if (isShowTips) {
    ElMessage({
      message: `提示：${res.engineer_name}和您建立了会话`,
      type: 'success'
    })
  }
  // 提交工程师信息到全局状态管理机中
  store.commit('dialog/SET_ENGINEER_INFO_MF', res)
})

// 状态码监听
cubeManual.on('manual_status_change', (res: any) => {
  // '0', //初始化状态也就是机器人中
  // '1', //正在转人工中（这个状态可以不监控，用来多次点击了按钮的兼容）
  // '4', //排队中
  // '5', //人工聊天中
  // 更新魔方转人工状态码
  store.commit('signals/SET_AGENT_STATUS_CHANGE_MF', res)
  // 设置状态码cookie
  setCookie('agentStatus', res)
  if (res === '5' || res === '4') {
    console.log('%c【当前建立转人工连接，人工对话中 或 排队】状态码为' + JSON.stringify(res), 'color:#000;background:#D5EEFF;padding:4px;border-radius:5px')
    // 提交转人工状态为 转人工状态
    store.commit('signals/SET_AGENT_SUCCESS_STATUS', true)
  } else if (res === '0') {
    console.log('%c【当前并未建立转人工连接 或 挂断成功】状态码为' + JSON.stringify(res), 'color:#000;background:#D5EEFF;padding:4px;border-radius:5px')
    // 提交转人工状态为 未转人工状态
    store.commit('signals/SET_AGENT_SUCCESS_STATUS', false)
    store.commit('signals/SET_TO_AGENT_STATUS', '')
  } else {
    store.commit('signals/SET_AGENT_SUCCESS_STATUS', false)
    store.commit('signals/SET_TO_AGENT_STATUS', '')
    console.log('%c【转人工状态码】' + JSON.stringify(res), 'color:#000;background:#D5EEFF;padding:4px;border-radius:5px')
  }
})

// 链接人工 如果没获取到队列和通路连接到个人测试账号的队列和通路 {intention: '账号问题', category: 'b' } QW001->1 QW005->7
export const connectAgent = ({intention = 'QW005', category = '7'}) => {
  const cubeOption = {
    userId: getCookie('userId') || store.getters['session/userId'] || '',
    orgId: getCookie('orgID') || '',
    serviceId: store.getters['session/serviceId'] || '',
    scenarioCode: category
  }
  // 开发环境固定调试账号
  if (env.indexOf('development') > -1) {
    const connectParams = {skill: 'QW001', accessId: '1', projectId: '', cubeOption: cubeOption}
    console.log('%c【转人工建立连接发送的参数】' + JSON.stringify(connectParams), 'color:#000;background:#D5EEFF;padding:4px;border-radius:5px')
    cubeManual.manualHandle(connectParams)
    return false
  }

  cubeManual.getTransferLaborQueue({intention: intention, category: category }).then((res:any) => {
    console.log('%c【转人工队列通路获取】' + JSON.stringify(res.data[0]), 'color:#000;background:#D5EEFF;padding:4px;border-radius:5px')
    const connectParams = {
      skill: res.data[0].queue.code,
      accessId: res.data[0].queue.access_id,
      projectId: '',
      cubeOption: cubeOption
    }
    if (window.botV2GlobalProperties.NODE_ENV === 'development') {
      connectParams.skill = 'QW005'
      connectParams.accessId = '7'
    }
    console.log('%c【转人工建立连接发送的参数】' + JSON.stringify(connectParams), 'color:#000;background:#D5EEFF;padding:4px;border-radius:5px')
    cubeManual.manualHandle(connectParams)
  })
}

// 挂断人工
export const disconnectAgent = () => {
  cubeManual.closeManul()
}

// 发送消息
export const sendMessage = (message: any) => {
  const messageId = message.id
  let sendMsgParams:any = {}
  // 图片参数组装
  if (message.payload.type === 'image') {
    sendMsgParams = {
      PicUrl: message.payload.content,
      MsgType: 'image'
    }
  }
  // 文本参数组装
  if (message.payload.type === 'text') {
    sendMsgParams = {
      Content: message.payload.content,
      MsgType: message.payload.type,
      citeMessageId: store.getters['dialog/messageReference'].id || undefined
    }
    // 如果有引用消息则添加引用消息参数
    if (store.getters['dialog/messageReference'].type === 'text') {
      sendMsgParams.reference = {
        type: 'text',
        content: store.getters['dialog/messageReference'].data.content,
        messageId: store.getters['dialog/messageReference'].id || undefined
      }
    } else if (store.getters['dialog/messageReference'].type === 'file') {
      sendMsgParams.reference = {
        type: 'file',
        file: store.getters['dialog/messageReference'].data.fileUrl,
        fileName: store.getters['dialog/messageReference'].data.fileName,
        fileType: store.getters['dialog/messageReference'].data.fileType,
        fileSize: store.getters['dialog/messageReference'].data.fileSize,
        messageId: store.getters['dialog/messageReference'].id || undefined
      }
    } else if (store.getters['dialog/messageReference'].type === 'image') {
      sendMsgParams.reference = {
        type: 'image',
        content: store.getters['dialog/messageReference'].data.fileUrl,
        messageId: store.getters['dialog/messageReference'].id || undefined
      }
    }
  }
  // 文件参数组装
  if (message.payload.type === 'file') {
    sendMsgParams = {
      MsgType: 'file',
      File: message.payload.url,
      FileName: message.payload.name,
      MediaUrl: message.payload.url,
      FileType: message.payload.fileType,
      FileSize: message.payload.size
    }
  }
  console.log('%c【转人工发送消息】' + JSON.stringify(sendMsgParams), 'color:#000;background:#D5EEFF;padding:4px;border-radius:5px')
  // message.payload.messageId || undefined
  cubeManual.sendMessageToManul(sendMsgParams).then((res:any) => {
    console.log('机器人生成的消息ID', messageId)
    console.log('魔方生成的消息ID', res.data.messageID)
    store.commit('dialog/CHANGE_USERMESSAGE_STATUS', {status: true, userMessageId: messageId})
    store.commit('dialog/SET_TALK_LIST_MSG_ID_FOR_MF', { messageId: messageId, messageIdMF: res.data.messageID })
    // console.log('魔方返回的用户消息ID：', res.data.messageID)
  }).catch((err:any) => {
    store.commit('dialog/CHANGE_USERMESSAGE_STATUS', {status: false, userMessageId: messageId})
    console.log(messageId)
    console.log('发送消息失败：', err)
  })
}

// 返回消息的处理方法
const resolveMessgae = (res: any) => {
  store.commit('session/SET_SESSION_ID_MF', res.MsgBody.MessageBody.SessionID)
  const isIncludeMessage = JSON.stringify(store.getters['dialog/talklist']).indexOf(res.MessageID) !== -1
  if (isIncludeMessage) {
    return false
  }
  const ClientType = res.MsgBody.MessageBody.ClientType
  if (ClientType === 'engineer' || ClientType === 'robot') {
    // 处理响应文本消息
    if (res.MsgBody.MessageBody.Body.Type === 'Text') {
      console.log('魔方响应数据文本消息：', res.MsgBody.MessageBody.Body.Content.Text)
      // name: ClientType !== 'robot' ? (store.getters['dialog/engineerInfoMF'].engineer_name || '') : (store.getters['global/pageConfig'].botNavigation.botTitle || ''),
      // avatar: ClientType !== 'robot' ? (store.getters['dialog/engineerInfoMF'].avgineer_avatar || '') : (store.getters['global/pageConfig'].botConfig.botLogo || ''),
      const textMsg = {
        templateType: 'text',
        id: res.MessageID,
        dialogInfo: {
          dialogRole: 'agent',
          name: res.MsgBody.MessageBody.engineer_name || store.getters['global/pageConfig'].botNavigation.botTitle || '',
          avatar: res.MsgBody.MessageBody.engineer_avatar || store.getters['global/pageConfig'].botConfig.botLogo || '',
          sendTime: res.MsgBody.MessageBody.SendTime || ''
        },
        sendMessageStatus: true,
        payload: {
          content: res.MsgBody.MessageBody.Body.Content.Text,
          messageId: res.MessageID,
          reference: {
            type: '',
            content: ''
          } as any
        }
      }

      // 组装回来的引用消息
      if (res.MsgBody.MessageBody.CiteMessageBody) {
        if (JSON.stringify(res.MsgBody.MessageBody.CiteMessageBody) !== '{}') {
          textMsg.payload.reference.type = res.MsgBody.MessageBody.CiteMessageBody.Type
          if (res.MsgBody.MessageBody.CiteMessageBody.Type === 'Text') {
            textMsg.payload.reference.content = res.MsgBody.MessageBody.CiteMessageBody.Content
          } else if (res.MsgBody.MessageBody.CiteMessageBody.Type === 'File') {
            textMsg.payload.reference.fileUrl = res.MsgBody.MessageBody.CiteMessageBody.Content.url
            textMsg.payload.reference.fileName = res.MsgBody.MessageBody.CiteMessageBody.Content.name
            textMsg.payload.reference.fileSize = res.MsgBody.MessageBody.CiteMessageBody.Content.size
            textMsg.payload.reference.fileType = res.MsgBody.MessageBody.CiteMessageBody.Content.media
          } else if (res.MsgBody.MessageBody.CiteMessageBody.Type === 'Image') {
            textMsg.payload.reference.fileUrl = res.MsgBody.MessageBody.CiteMessageBody.Content
          }
        }
      } else {
        textMsg.payload.reference = null
      }

      // 处理回来的文本消息到消息左侧
      store.commit('dialog/SET_TALK_LIST', [textMsg])

      // 更新消息列表滚动条
      store.dispatch('dialog/botMessageFn', textMsg)
      return false
    }
    // 处理图片消息
    if (res.MsgBody.MessageBody.Body.Type === 'Image') {
      console.log('魔方响应数据图片消息：', res.MsgBody.MessageBody.Body)
      const textMsg = {
        templateType: 'AnswerImage',
        id: res.MessageID,
        dialogInfo: {
          dialogRole: 'agent',
          name: res.MsgBody.MessageBody.engineer_name || '',
          avatar: res.MsgBody.MessageBody.engineer_avatar || '',
          sendTime: res.MsgBody.MessageBody.SendTime || ''
        },
        payload: {
          fileUrl: res.MsgBody.MessageBody.Body.Content.Text,
          fileName: '',
          fileSize: '',
          fileType: ''
        }
      }

      // 处理回来的文本消息到消息左侧
      store.commit('dialog/SET_TALK_LIST', [textMsg])

      // 更新消息列表滚动条
      store.dispatch('dialog/botMessageFn', textMsg)
      return false
    }
    // 处理文件消息
    if (res.MsgBody.MessageBody.Body.Type === 'File') {
      console.log('魔方响应数据文件消息：', res.MsgBody.MessageBody.Body)
      const textMsg = {
        templateType: 'AnswerFile',
        id: res.MessageID,
        dialogInfo: {
          dialogRole: 'agent',
          name: res.MsgBody.MessageBody.engineer_name || '',
          avatar: res.MsgBody.MessageBody.engineer_avatar || '',
          sendTime: res.MsgBody.MessageBody.SendTime || ''
        },
        payload: {
          fileUrl: res.MsgBody.MessageBody.Body.Content.MediaUrl,
          fileName: res.MsgBody.MessageBody.Body.Content.FileName,
          fileSize: res.MsgBody.MessageBody.Body.Content.FileSize,
          fileType: res.MsgBody.MessageBody.Body.Content.FileType
        }
      }

      // 处理回来的文本消息到消息左侧
      store.commit('dialog/SET_TALK_LIST', [textMsg])

      // 更新消息列表滚动条
      store.dispatch('dialog/botMessageFn', textMsg)
      return false
    }
    // 处理评价消息
    if (res.MsgBody.MessageBody.Body.Type === 'Comment') {
      console.log('魔方响应Survey消息：', res.MsgBody.MessageBody.Body)
      // name: ClientType !== 'robot' ? (store.getters['dialog/engineerInfoMF'].engineer_name || '') : (store.getters['global/pageConfig'].botNavigation.botTitle || ''),
      // avatar: ClientType !== 'robot' ? (store.getters['dialog/engineerInfoMF'].avgineer_avatar || '') : (store.getters['global/pageConfig'].botConfig.botLogo || ''),
      const textMsg = {
        templateType: 'agentSurveyMF',
        id: res.MessageID,
        dialogInfo: {
          dialogRole: 'agent',
          name: res.MsgBody.MessageBody.engineer_name || '',
          avatar: res.MsgBody.MessageBody.engineer_avatar || '',
          sendTime: res.MsgBody.MessageBody.SendTime || ''
        },
        sendMessageStatus: true,
        payload: {
          SendTime: res.MsgBody.MessageBody.SendTime,
          MessageID: res.MessageID,
          SessionID: res.MsgBody.MessageBody.SessionID,
          ...res.MsgBody.MessageBody.Body.Content
        }
      }


      // 处理回来的文本消息到消息左侧
      store.commit('dialog/SET_TALK_LIST', [textMsg])

      // 更新消息列表滚动条
      store.dispatch('dialog/botMessageFn', textMsg)
      return false
    }
  } else {
    // 用户一侧的消息
    // 处理响应文本消息
    if (res.MsgBody.MessageBody.Body.Type === 'Text') {
      console.log('USER-魔方响应数据文本消息：', res.MsgBody.MessageBody.Body.Content.Text)
      const textMsg = {
        templateType: 'user',
        id: res.MessageID,
        dialogInfo: {
          dialogRole: 'user',
          name: '用户',
          avatar: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiBhcmlhLWhpZGRlbj0idHJ1ZSIgcm9sZT0iaW1nIiBjbGFzcz0iaWNvbmlmeSBpY29uaWZ5LS1waCIgd2lkdGg9IjFlbSIgaGVpZ2h0PSIxZW0iIHByZXNlcnZlQXNwZWN0UmF0aW89InhNaWRZTWlkIG1lZXQiIHZpZXdCb3g9IjAgMCAyNTYgMjU2Ij48cGF0aCBmaWxsPSIjNWM3Y2JjIiBkPSJNMTcyIDEyMGE0NCA0NCAwIDEgMS00NC00NGE0NCA0NCAwIDAgMSA0NCA0NFptNjAgOEExMDQgMTA0IDAgMSAxIDEyOCAyNGExMDQuMiAxMDQuMiAwIDAgMSAxMDQgMTA0Wm0tMTYgMGE4OCA4OCAwIDEgMC0xNTMuOCA1OC40YTgxLjMgODEuMyAwIDAgMSAyNC41LTIzYTU5LjcgNTkuNyAwIDAgMCA4Mi42IDBhODEuMyA4MS4zIDAgMCAxIDI0LjUgMjNBODcuNiA4Ny42IDAgMCAwIDIxNiAxMjhaIj48L3BhdGg+PC9zdmc+',
          sendTime: res.MsgBody.MessageBody.SendTime || ''
        },
        sendMessageStatus: true,
        payload: {
          type: 'text',
          content: res.MsgBody.MessageBody.Body.Content.Text,
          messageId: res.MessageID,
          reference: null as any
        }
      }
      // 用户侧引用文本消息
      if (res.MsgBody.MessageBody.CiteMessageBody.Type === 'Text') {
        textMsg.payload.reference = {
          type: 'text',
          content: res.MsgBody.MessageBody.CiteMessageBody.Content || ''
        }
      }
      // 用户侧引用图片消息
      if (res.MsgBody.MessageBody.CiteMessageBody.Type === 'Image') {
        textMsg.payload.reference = {
          type: 'image',
          content: res.MsgBody.MessageBody.CiteMessageBody.Content || ''
        }
      }
      // 用户侧引用文件消息
      if (res.MsgBody.MessageBody.CiteMessageBody.Type === 'File') {
        textMsg.payload.reference = {
          type: 'file',
          fileUrl: res.MsgBody.MessageBody.CiteMessageBody.Content.url || '',
          fileName: res.MsgBody.MessageBody.CiteMessageBody.Content.name,
          fileSize: res.MsgBody.MessageBody.CiteMessageBody.Content.size,
          fileType: res.MsgBody.MessageBody.CiteMessageBody.Content.media
        }
      }

      // 处理回来的user文本消息到消息右侧
      store.commit('dialog/SET_TALK_LIST', [textMsg])

      // 更新消息列表滚动条
      store.dispatch('dialog/botMessageFn', textMsg)
      return false
    }
    // 处理图片消息
    if (res.MsgBody.MessageBody.Body.Type === 'Image') {
      console.log('USER-魔方响应数据图片消息：', res.MsgBody.MessageBody.Body)
      const textMsg = {
        templateType: 'user',
        id: res.MessageID,
        dialogInfo: {
          dialogRole: 'user',
          name: '用户',
          avatar: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiBhcmlhLWhpZGRlbj0idHJ1ZSIgcm9sZT0iaW1nIiBjbGFzcz0iaWNvbmlmeSBpY29uaWZ5LS1waCIgd2lkdGg9IjFlbSIgaGVpZ2h0PSIxZW0iIHByZXNlcnZlQXNwZWN0UmF0aW89InhNaWRZTWlkIG1lZXQiIHZpZXdCb3g9IjAgMCAyNTYgMjU2Ij48cGF0aCBmaWxsPSIjNWM3Y2JjIiBkPSJNMTcyIDEyMGE0NCA0NCAwIDEgMS00NC00NGE0NCA0NCAwIDAgMSA0NCA0NFptNjAgOEExMDQgMTA0IDAgMSAxIDEyOCAyNGExMDQuMiAxMDQuMiAwIDAgMSAxMDQgMTA0Wm0tMTYgMGE4OCA4OCAwIDEgMC0xNTMuOCA1OC40YTgxLjMgODEuMyAwIDAgMSAyNC41LTIzYTU5LjcgNTkuNyAwIDAgMCA4Mi42IDBhODEuMyA4MS4zIDAgMCAxIDI0LjUgMjNBODcuNiA4Ny42IDAgMCAwIDIxNiAxMjhaIj48L3BhdGg+PC9zdmc+',
          sendTime: res.MsgBody.MessageBody.SendTime || ''
        },
        sendMessageStatus: true,
        payload: {
          type: 'image',
          fileUrl: res.MsgBody.MessageBody.Body.Content.Text,
          fileName: '',
          fileSize: '',
          fileType: ''
        }
      }

      // 处理回来的文本消息到消息左侧
      store.commit('dialog/SET_TALK_LIST', [textMsg])

      // 更新消息列表滚动条
      store.dispatch('dialog/botMessageFn', textMsg)
      return false
    }
    // 处理文件消息
    if (res.MsgBody.MessageBody.Body.Type === 'File') {
      console.log('魔方响应数据文件消息：', res.MsgBody.MessageBody.Body)
      const textMsg = {
        templateType: 'user',
        id: res.MessageID,
        dialogInfo: {
          dialogRole: 'user',
          name: '用户',
          avatar: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiBhcmlhLWhpZGRlbj0idHJ1ZSIgcm9sZT0iaW1nIiBjbGFzcz0iaWNvbmlmeSBpY29uaWZ5LS1waCIgd2lkdGg9IjFlbSIgaGVpZ2h0PSIxZW0iIHByZXNlcnZlQXNwZWN0UmF0aW89InhNaWRZTWlkIG1lZXQiIHZpZXdCb3g9IjAgMCAyNTYgMjU2Ij48cGF0aCBmaWxsPSIjNWM3Y2JjIiBkPSJNMTcyIDEyMGE0NCA0NCAwIDEgMS00NC00NGE0NCA0NCAwIDAgMSA0NCA0NFptNjAgOEExMDQgMTA0IDAgMSAxIDEyOCAyNGExMDQuMiAxMDQuMiAwIDAgMSAxMDQgMTA0Wm0tMTYgMGE4OCA4OCAwIDEgMC0xNTMuOCA1OC40YTgxLjMgODEuMyAwIDAgMSAyNC41LTIzYTU5LjcgNTkuNyAwIDAgMCA4Mi42IDBhODEuMyA4MS4zIDAgMCAxIDI0LjUgMjNBODcuNiA4Ny42IDAgMCAwIDIxNiAxMjhaIj48L3BhdGg+PC9zdmc+',
          sendTime: res.MsgBody.MessageBody.SendTime || ''
        },
        sendMessageStatus: true,
        payload: {
          type: 'file',
          fileUrl: res.MsgBody.MessageBody.Body.Content.MediaUrl,
          fileName: res.MsgBody.MessageBody.Body.Content.FileName,
          fileSize: res.MsgBody.MessageBody.Body.Content.FileSize,
          fileType: res.MsgBody.MessageBody.Body.Content.FileType
        }
      }

      // 处理回来的文本消息到消息左侧
      store.commit('dialog/SET_TALK_LIST', [textMsg])

      // 更新消息列表滚动条
      store.dispatch('dialog/botMessageFn', textMsg)
      return false
    }
  }
}

// 收消息
cubeManual.on('soceket_message', (res: any) => {
  console.log('%c【转人工接消息 soceket_message】' + JSON.stringify(res), 'color:#000;background:#D5EEFF;padding:4px;border-radius:5px')
  resolveMessgae(res[0])
})

// 收消息（网络异常重连后）
cubeManual.on('socket_offline_messages', (res: any) => {
  console.log('%c【断网重连消息列表 socket_offline_messages】' + JSON.stringify(res), 'color:#000;background:#D5EEFF;padding:4px;border-radius:5px')
  res.forEach((item: any) => {
    // 收到的消息是否是重复的
    const isIncludeMessage = JSON.stringify(store.getters['dialog/talklist']).indexOf(item.MessageID) !== -1
    // 如果不是重复的消息，就推送给用户
    if (!isIncludeMessage) {
      resolveMessgae(item)
    } else {
      console.log('%c【重复消息已过滤】' + JSON.stringify(item), 'color:#000;background:#D5EEFF;padding:4px;border-radius:5px')
    }
  })
})

// 收消息（转人工历史工程师侧记录）
cubeManual.on('manual_history_message_list', (res: any) => {
  // 打印警告，已经废弃魔方sdk manual_history_message_list 事件的监听
  console.warn('已经废弃魔方sdk manual_history_message_list 事件的监听', res)
  // console.log('%c【转人工历史记录 manual_history_message_list】' + JSON.stringify(res), 'color:#000;background:#D5EEFF;padding:4px;border-radius:5px')
  // // 遍历所有消息，依次解析推进消息列表
  // res.forEach((item: any) => {
  //   resolveMessgae(item)
  // })
})

// 网络异常监听，提示异常话术
let networkError:any
cubeManual.on('socket_disconnect', (res: string) => {
  console.log('%c【网络异常 socket_disconnect】' + JSON.stringify(res), 'color:#000;background:#D5EEFF;padding:4px;border-radius:5px')
  networkError = ElMessage({
    duration: 0,
    message: res,
    type: 'error'
  })
})

// 网络恢复监听，提示成功话术
cubeManual.on('socket_reconnected', (res: string) => {
  console.log('%c【网络恢复 socket_reconnected 】' + JSON.stringify(res), 'color:#000;background:#D5EEFF;padding:4px;border-radius:5px')
  networkError.close()
  ElMessage({
    message: res,
    type: 'success'
  })
})

// 转人工时用户打开多标签页或多标签页
cubeManual.on('socket_kickoff', (res: string) => {
  console.log('%c【转人工时用户打开多标签 socket_kickoff 】' + JSON.stringify(res), 'color:#000;background:#D5EEFF;padding:4px;border-radius:5px')
  ElMessage({
    showClose: true,
    duration: 0,
    message: res,
    type: 'warning'
  })
})

// 输入框实时监听
export const inputChange = (message: string) => {
  cubeManual.sendIntellisense(message)
}

// 主动邀请评价工程师
export const startComment = (e:Event) => {
  // 阻止默认动作
  e.preventDefault()
  // 多次点击触发一次
  throttle(() => {
    console.log('service id', store.getters['session/sessionIdMF'])
    // 发起邀评
    cubeManual.startComment({'session_id': store.getters['session/sessionIdMF'] || ''}).then((res: any) => {
      console.log('%c【用户主动邀评成功数据 startComment】' + JSON.stringify(res), 'color:#000;background:#D5EEFF;padding:4px;border-radius:5px')
      if (res.statusCode !== 200) {
        ElMessage.error(res.message.info + '😊')
      }
    }).catch((err: any) => {
      console.log('%c【用户主动邀评失败数据 startComment】' + JSON.stringify(err), 'color:#000;background:#D5EEFF;padding:4px;border-radius:5px')
    })
  }, 500)
}

interface saveCommentParams {
  'session_id': string,
  'level': string,
  'is_resolve': string,
  'multiOption': string[],
  'message_id': string,
  'content'?: string
}

/**
 * @description 用户提交评价数据
 * @param { saveCommentParams } params
 */
export const saveComment = (params: saveCommentParams) => {
  console.log('%c【用户提交评价数据 saveComment' + JSON.stringify(params), 'color:#000;background:#D5EEFF;padding:4px;border-radius:5px')
  return new Promise((resolve) => {
    cubeManual.saveComment(params).then((res: any) => {
      resolve(res)
    })
  })
}
